type IconProps = {
  className?: string;
  size?: number;
};

export function IconUnlock({ className = "", size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill="currentColor"
        d="M21.9 10.836H10.1V9.607c0-3.393 2.64-6.145 5.899-6.146 2.146-.001 4.124 1.213 5.164 3.17.316.593 1.035.807 1.604.478.57-.33.776-1.078.46-1.672-2.21-4.156-7.237-5.66-11.228-3.359-2.629 1.516-4.26 4.4-4.259 7.53v1.75c-2.147.976-3.537 3.183-3.54 5.623v7.374c.004 3.392 2.643 6.14 5.9 6.145h11.8c3.257-.004 5.896-2.753 5.9-6.145v-7.374c-.004-3.392-2.643-6.14-5.9-6.145Zm-4.72 11.061c0 .679-.528 1.229-1.18 1.229-.652 0-1.18-.55-1.18-1.229v-2.458c0-.679.528-1.229 1.18-1.229.652 0 1.18.55 1.18 1.23v2.457Z"
      />
    </svg>
  );
}
